/**
 * Conditionally mounts the Privy SDK provider.
 *
 * When VITE_PRIVY_APP_ID is missing, renders children without Privy so
 * the marketing site and unauthenticated routes still work in dev.
 * useSignIntent() guards against being called when Privy isn't mounted.
 */
import type { ReactNode } from 'react';
import { PrivyProvider } from '@privy-io/react-auth';
import { PRIVY_APP_ID, PRIVY_CONFIGURED, privyConfig } from '@/lib/privy';

export function PrivyAppProvider({ children }: { children: ReactNode }) {
  if (!PRIVY_CONFIGURED) {
    return <>{children}</>;
  }
  return (
    <PrivyProvider appId={PRIVY_APP_ID} config={privyConfig}>
      {children}
    </PrivyProvider>
  );
}
